<div class="filter-dialog">
	<div class="bg info"></div>
	<p>¿Quieres comprobar qué lactaciones son certificables teniendo en cuenta los filtros actuales?</p>
	<p>
		AVISO: Es un proceso lento y por ello se recomienda recalcular con filtros, por ejemplo seleccionando por
		ganadería.
	</p>
	<button class="app-btn tertiary" (click)="closeDialog('filters')">
		Sí, <span class="italics">continuar con filtros actuales </span>
	</button>
	<!-- <button class="app-btn tertiary" (click)="closeDialog('all')">
		No, <span class="italics">continuar sin filtros</span>
	</button> -->
	<button class="app-btn optional" (click)="closeDialog(null)">Cancelar</button>
	<div class="checkbox-container">
		<p-checkbox [binary]="true" [(ngModel)]="isHistoricFilterEnabled"></p-checkbox>
		<span class="dark-blue"> Incluir lactaciones históricas</span>
	</div>
</div>
